import { diasHasta, hoyLocal } from "./fechas.js";

/**
 * Alertas de vencimiento (fase 2, pantalla 08). "La alerta nace sola en la fecha de vencimiento
 * menos los días de anticipación. Nadie tiene que acordarse."
 *
 * Cuatro tipos. "Revisión próxima" y "Revisión vencida" son la misma alerta vista antes y
 * después de su fecha, igual que la retención: el badge sale de `venceEl`, no del tipo.
 */
export const TIPOS_ALERTA = [
  "revision_anual",
  "retencion",
  "firma_pendiente",
  "acuses_incompletos",
] as const;
export type TipoAlerta = (typeof TIPOS_ALERTA)[number];

/** Cómo se cerró una alerta. `atendida` = el job vio que la condición ya no se cumple. */
export const RESOLUCIONES_ALERTA = [
  "ratificada",
  "nueva_revision",
  "dispuesto",
  "atendida",
] as const;
export type ResolucionAlerta = (typeof RESOLUCIONES_ALERTA)[number];

/** Panel "Cómo y cuándo avisar": las cuatro reglas, en días, con los valores del mockup. */
export const REGLAS_ALERTAS_POR_DEFECTO = {
  revision_dias_antes: 30,
  retencion_dias_antes: 30,
  firma_recordar_cada_dias: 3,
  acuses_recordar_a_los_dias: 7,
} as const;
export type ClaveReglaAlerta = keyof typeof REGLAS_ALERTAS_POR_DEFECTO;
export type ReglasAlertas = Record<ClaveReglaAlerta, number>;
export const CLAVES_REGLAS_ALERTAS = Object.keys(REGLAS_ALERTAS_POR_DEFECTO) as ClaveReglaAlerta[];

export const NOMBRE_REGLA_ALERTA: Record<ClaveReglaAlerta, { etiqueta: string; unidad: string }> = {
  revision_dias_antes: { etiqueta: "Revisión anual: avisar", unidad: "días antes" },
  retencion_dias_antes: { etiqueta: "Retención de registros: avisar", unidad: "días antes" },
  firma_recordar_cada_dias: { etiqueta: "Firma sin responder: recordar cada", unidad: "días" },
  acuses_recordar_a_los_dias: { etiqueta: "Acuses de lectura: recordar a los", unidad: "días" },
};

/** Los grupos de la pantalla 08. `despues` = abierta, pero todavía a más de un mes. */
const URGENCIAS = ["vencida", "semana", "mes", "despues"] as const;
export type Urgencia = (typeof URGENCIAS)[number];

export function urgenciaDe(venceEl: Date, hoy: Date = hoyLocal()): Urgencia {
  const dias = diasHasta(venceEl, hoy);
  if (dias < 0) return "vencida";
  if (dias <= 7) return "semana";
  if (dias <= 31) return "mes";
  return "despues";
}

/** El badge de la fila: el tipo, matizado por si la fecha ya pasó. */
export function badgeDeAlerta(tipo: TipoAlerta, venceEl: Date, hoy: Date = hoyLocal()): string {
  const vencida = diasHasta(venceEl, hoy) < 0;
  switch (tipo) {
    case "revision_anual":
      return vencida ? "Revisión vencida" : "Revisión próxima";
    case "retencion":
      return vencida ? "Retención cumplida" : "Retención por vencer";
    case "firma_pendiente":
      return "Firma pendiente";
    case "acuses_incompletos":
      return "Acuses incompletos";
  }
}
